import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const ServicesTwo = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "wwd2.jpg" }) {
        childImageSharp {
          fixed(quality: 80, width: 720) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  return (
    <Img
      style={{ height: "100%" }}
      fluid={data.placeholderImage.childImageSharp.fixed}
    />
  )
}

export default ServicesTwo
